import { useCreateContactBankAccountMutation } from 'hooks/mutations/Contacts/useCreateContactBankAccount'
import { useCreateContactBankAccount2FAMutation } from 'hooks/mutations/Contacts/useCreateContactBankAccount2FAMutation'
import { BaseErrorResponse } from 'types/beneficiaries'
import { CreateContactBankAccountInstrumentProps } from 'types/contacts'
import { TwoFAAuthRequest } from 'types/generics'

interface UseCreateContactBankAccountProps {
  onSubmitBankAccountSuccess: (error: BaseErrorResponse) => void
  onSubmitBankAccountError: (error: BaseErrorResponse) => void
  onSubmit2FASuccess: () => void
  onSubmit2FAError: (error: BaseErrorResponse) => void
}

export const useCreateContactBankAccount = ({
  onSubmitBankAccountSuccess,
  onSubmitBankAccountError,
  onSubmit2FASuccess,
  onSubmit2FAError,
}: UseCreateContactBankAccountProps) => {
  const {
    mutate: postBankAccount,
    isPending: isSubmittingBankAccount,
    error: submitBankAccountError,
  } = useCreateContactBankAccountMutation()

  const {
    mutate: post2Fa,
    isPending: isSubmitting2Fa,
    error: submit2faError,
  } = useCreateContactBankAccount2FAMutation()

  const handleOnSubmitBankAccountError = (error: BaseErrorResponse) => {
    if (error?.status === 428) {
      onSubmitBankAccountSuccess?.(error)
      return
    }

    onSubmitBankAccountError?.(error)
  }

  const createBankAccount = (payload: CreateContactBankAccountInstrumentProps) => {
    postBankAccount(payload, {
      onError: handleOnSubmitBankAccountError,
    })
  }

  const submit2Fa = (payload: TwoFAAuthRequest) => {
    post2Fa(payload, {
      onSuccess: onSubmit2FASuccess,
      onError: onSubmit2FAError,
    })
  }

  return {
    isSubmittingBankAccount,
    submitBankAccountError,
    createBankAccount,
    isSubmitting2Fa,
    submit2faError,
    submit2Fa,
  }
}
